<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <transition name="fade">
          <div class="wrapper" v-if="$parent.textPageTitle">
            <div class="title align-left">{{$parent.textPageTitle}}</div>

            <div class="checkout-step-list">
              <div class="checkout-step-list__item">
                <div class="desc" v-html="$parent.textPageHeader"></div>
                <div class="desc" v-html="$parent.textPageContent"></div>
              </div>
            </div>


          </div>
        </transition>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'TextPage',
  props: [],
  components: {
  },
  watch: {
    '$route.params.id'(id) {
      if (id) this.$parent.getTextPageContent(id);
    },
    '$route.params.slug'(slug) {
      if (slug) this.$parent.getTextPageContent(slug);
    }
  },
  data: function() {
    return {
      
    }
  },
  mounted() {
    const identifier = this.$route.params.slug || this.$route.params.id;
    if (identifier) {
      this.$parent.getTextPageContent(identifier);
    } else {
      this.$router.replace({ name: 'PageNotFound' });
    }
  },
  methods: {
    
  }
}
</script>